// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2oabn{line-height:1.2;margin-top:32px;text-align:center}._2oXIv{margin-bottom:-16px}._2oXIv,._1Lfwb{height:60px;height:6rem;position:relative;width:60px;width:6rem}._1Lfwb{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#c9cfdc;border-radius:8px;justify-content:center;overflow:hidden}._2wVLq{max-height:100%;width:auto}.tqggK{color:#fff;display:block;font-size:32px;font-size:3.2rem;font-weight:700;height:41px;height:4.1rem}._1nO4y{color:#30a8ff;font-size:24px;font-size:2.4rem;font-weight:700;padding:3rem 0}@media (min-width:1024px){._1nO4y{font-size:3.6rem}}._3KWew{display:-ms-flexbox;display:flex;font-size:16px;font-size:1.6rem;margin-bottom:40px;margin-top:56px;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._1mH1o{margin:4px;padding:0 0 0 10px;width:32px}.NjFtD{margin-top:16px}._17A9X{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:8px}", ""]);
// Exports
exports.locals = {
	"root": "_2oabn",
	"avatar": "_2oXIv",
	"avatar__imgWrapper": "_1Lfwb",
	"avatar__img": "_2wVLq",
	"avatar__initials": "tqggK",
	"clinicName": "_1nO4y",
	"info": "_3KWew",
	"numberInput": "_1mH1o",
	"licenceButton": "NjFtD",
	"header": "_17A9X"
};
module.exports = exports;
